export enum PointsReportType {
  NETTO_POINTS = "NETTO_POINTS",
  NETTO_AND_BRUTTO_POINTS = "NETTO_AND_BRUTTO_POINTS",
  BRUTTO_POINTS = "BRUTTO_POINTS",
  COMMISSION_AMOUNTS = "COMMISSION_AMOUNTS",
}

export enum PointsReportOrderByColumn {
  AGENT = "AGENT",
  TOTAL_INDIVIDUAL_NETTO_POINTS = "TOTAL_INDIVIDUAL_NETTO_POINTS",
  TOTAL_GROUP_NETTO_POINTS = "TOTAL_GROUP_NETTO_POINTS",
  TOTAL_NETTO_POINTS_SUM = "TOTAL_NETTO_POINTS_SUM",
  TOTAL_INDIVIDUAL_BRUTTO_POINTS = "TOTAL_INDIVIDUAL_BRUTTO_POINTS",
  TOTAL_GROUP_BRUTTO_POINTS = "TOTAL_GROUP_BRUTTO_POINTS",
  TOTAL_BRUTTO_POINTS_SUM = "TOTAL_BRUTTO_POINTS_SUM",
  PERIOD_INDIVIDUAL_NETTO_POINTS = "PERIOD_INDIVIDUAL_NETTO_POINTS",
  PERIOD_GROUP_NETTO_POINTS = "PERIOD_GROUP_NETTO_POINTS",
  PERIOD_NETTO_POINTS_SUM = "PERIOD_NETTO_POINTS_SUM",
  PERIOD_INDIVIDUAL_BRUTTO_POINTS = "PERIOD_INDIVIDUAL_BRUTTO_POINTS",
  PERIOD_GROUP_BRUTTO_POINTS = "PERIOD_GROUP_BRUTTO_POINTS",
  PERIOD_BRUTTO_POINTS_SUM = "PERIOD_BRUTTO_POINTS_SUM",
  TOTAL_COMMISSION_AMOUNT = "TOTAL_COMMISSION_AMOUNT",
  PERIOD_COMMISSION_AMOUNT = "PERIOD_COMMISSION_AMOUNT",
}
